export default class QueryString
{
    constructor(urlParams) {
        this.urlParams = urlParams.getParams();
        this.baseUrl = urlParams.getBaseUrl();
    }

    get(key) {
        return this.urlParams[key];
    }

    add(newKey, newValue) {
        var queryString = [];

        for (var i in this.urlParams) {
            if (i != newKey && i != 'page') {
                queryString.push(i+'='+this.urlParams[i]);
            }
        }

        queryString.push(newKey+'='+newValue);
        return this.baseUrl+'?'+queryString.join('&');
    }

    remove(key) {
        var queryString = [];

        for (var i in this.urlParams) {
            if (i != key)
                queryString.push(i+'='+this.urlParams[i]);
        }

        return this.baseUrl+'?'+queryString.join('&');
    }
}



// WEBPACK FOOTER //
// ./app/QueryString.js